/**
 * @fileoverview Arquivo responsável por definir as traduções em português da aplicação.
 */

const messages = {
  pt: {
    translations: {
      selectLanguage: "Selecione um idioma",
      onboarding: {
        title: "Configuração da sua conta",
        subtitle: "Conclua as etapas e comece a operar",
        minimize: "Minimizar",
        requiredTag: "Obrigatória",
        of: "de",
        stepsDone: "etapas concluídas",
        groups: {
          required: "Obrigatórias",
          optional: "Opcionais (recomendadas)",
        },
        cta: {
          iniciar: "Iniciar",
          continuar: "Continuar",
          revisar: "Revisar",
          retomar: "Retomar",
          pular: "Pular",
        },
        tour: {
          gotit: "Entendi",
        },
        celebration: {
          taskDone: "Boa! Mais uma etapa concluída 🎉",
          aha: "Parabéns! Sua IA foi criada com sucesso",
          allDone: "Excelente! Você concluiu as etapas principais do onboarding 🏆",
        },
        trial: {
          prefix: "Período de teste:",
          daysLeft: "dias restantes",
          dayLeft: "dia restante",
          lastDay: "último dia",
        },
        blocked: {
          title: "Conta pausada",
          titleCancelled: "Conta cancelada",
          desc: "Seu período de teste terminou e não identificamos um pagamento confirmado. Regularize para voltar a usar o Sttelar Chat.",
          descCancelled: "Esta conta foi cancelada. Entre em contato para reativar.",
          payCta: "Regularizar pagamento",
          updateCard: "Atualizar forma de pagamento",
          contact: "Entre em contato com o suporte para regularizar.",
          pausedAdminContact: "Fale com o administrador da sua conta para regularizar o pagamento e reativar o acesso.",
        },
        checkout: {
          title: "Escolha seu plano",
          desc: "Seu teste grátis terminou. Selecione um plano para continuar usando o Sttelar Chat.",
          basic: "Basic",
          pro: "Pro",
          basicDesc: "Atendimento humano organizado",
          proDesc: "Atendimento com IA + humanos",
          aiSeatNote: "A IA conta como 1 usuário",
          aiSeatTooltip: "No plano Pro, a IA é cobrada como 1 usuário do plano. Ex.: 2 atendentes humanos + IA = 3 usuários cobráveis.",
          features: {
            basic: [
              "Fluxos de Chatbot",
              "Relatórios Detalhados",
              "Respostas Rápidas Ilimitadas",
              "CRM integrado ao WhatsApp",
              "Centralização do atendimento"
            ],
            pro: [
              "Tudo do Plano Basic",
              "Atendimento 24/7 com IA",
              "IA Personalizada para o seu negócio"
            ]
          },
          monthly: "Mensal",
          annual: "Anual",
          annualSave: "−16%",
          users: "Usuários",
          minNote: "Cobrança mínima de 3 usuários",
          addon: "Chat Interno",
          addonHint: "Comunicação interna entre equipes (por usuário)",
          billable: "usuários cobráveis",
          perMonth: "/mês",
          cta: "Continuar para pagamento",
          cardTitle: "Pagamento",
          cardDesc: "Cobrança recorrente no cartão de crédito.",
          cardNumber: "Número do cartão",
          cardHolder: "Nome no cartão",
          expMonth: "Mês",
          expYear: "Ano",
          expiry: "Validade",
          acceptedBrands: "Bandeiras aceitas",
          cvv: "CVV",
          pay: "Pagar",
          processing: "Processando...",
          fillCard: "Preencha todos os dados do cartão.",
          payError: "Não foi possível concluir o pagamento",
          successTitle: "Pagamento recebido!",
          confirmingTitle: "Confirmando pagamento...",
          successDesc: "Sua assinatura foi criada. Sua conta será liberada em instantes.",
          releasingDesc: "Estamos confirmando seu pagamento. Sua conta será liberada em instantes.",
          stillReleasingDesc: "Recebemos seu pagamento. A liberação pode levar mais alguns instantes — você já pode acessar.",
          releasedTitle: "Conta liberada!",
          releasedDesc: "Tudo certo! Você já tem acesso completo ao Sttelar Chat.",
          access: "Acessar agora",
          closeNow: "Fechar",
          paymentMethod: "Forma de pagamento",
          payCard: "Cartão de crédito",
          payPix: "PIX",
          pixOnlyAnnualShort: "Só no plano anual",
          pixTitle: "Pague com PIX",
          pixDesc: "Escaneie o QR code ou copie o código. A liberação é automática após o pagamento.",
          pixCopy: "Copiar código",
          pixCopied: "Copiado!",
          pixWaiting: "Aguardando pagamento...",
          back: "Voltar",
          annualCharge: "Cobrado por ano",
          secureNote: "Pagamento processado com segurança pelo Pagar.me. Não armazenamos os dados do seu cartão.",
          stepPlan: "Plano",
          stepBilling: "Cobrança",
          stepPayment: "Pagamento",
          next: "Continuar",
          toBilling: "Prosseguir para cobrança",
          toPayment: "Prosseguir para pagamento",
          billingTitle: "Dados de cobrança",
          billingDesc: "Usados para emissão e segurança do pagamento.",
          document: "CPF / CNPJ",
          phone: "Telefone",
          cep: "CEP",
          street: "Endereço",
          number: "Número",
          complement: "Complemento",
          neighborhood: "Bairro",
          city: "Cidade",
          state: "UF",
          optional: "Opcional",
          fillBilling: "Preencha os dados de cobrança obrigatórios.",
          supportWhatsappMessage: "Estou na etapa de escolha do plano do Sttelar Chat e tenho uma dúvida",
          supportTooltip: "Tirar dúvidas com o suporte da Sttelar no WhatsApp",
          logoutTooltip: "Sair da conta",
          logout: "Sair",
          documentPlaceholder: "CPF ou CNPJ",
          numberPlaceholder: "Nº",
          streetPlaceholder: "Logradouro",
          statePlaceholder: "UF",
          cardHolderPreview: "NOME NO CARTÃO",
          cardHolderPlaceholder: "NOME COMO NO CARTÃO",
          pixQrAlt: "QR Code PIX",
          aiSeatSuffix: " (+IA)",
        },
        upgrade: {
          loadError: "Não foi possível carregar os dados do plano.",
          confirmError: "Não foi possível concluir o upgrade",
          titleInternal: "Adicionar Chat Interno",
          titleAttendance: "Adicionar usuários",
          descInternal: "Aumente a quantidade de usuários de Chat Interno do seu plano.",
          descAttendance: "Aumente a quantidade de usuários do seu plano.",
          descNextCharge: " O novo valor entrará na próxima cobrança.",
          close: "Fechar",
          successTitle: "Assentos atualizados!",
          successInternal: "Agora você tem {{count}} assentos de Chat Interno.",
          successAttendance: "Agora você tem {{count}} usuários no plano.",
          planUnavailable: "Plano indisponível.",
          planRowInternal: "Plano {{tier}} · {{ciclo}} · hoje {{count}} Chat Interno",
          planRowAttendance: "Plano {{tier}} · {{ciclo}} · hoje {{count}} {{usersWord}}",
          cycleAnnual: "Anual",
          cycleMonthly: "Mensal",
          userSingular: "usuário",
          userPlural: "usuários",
          newTotalInternal: "Novo total de Chat Interno",
          newTotalAttendance: "Novo total de usuários",
          minHint: "Mínimo {{min}} (1 a mais que o atual)",
          perMonth: "por mês",
          billedAnnually: " · cobrado anualmente",
          breakInternal: "{{addon}} Chat Interno · {{seats}} cobráveis{{ai}}",
          breakAttendance: "{{seats}} assentos cobráveis{{ai}}",
          aiSuffix: " (+IA)",
          processing: "Processando...",
          confirm: "Confirmar upgrade",
          footnote: "O valor extra é cobrado a partir do próximo ciclo. Você pode reduzir depois falando com o suporte.",
        },
        changeCard: {
          notConfigured: "Pagamento não configurado (chave pública ausente).",
          fillAllFields: "Preencha todos os dados do cartão.",
          saveError: "Não foi possível trocar o cartão",
          title: "Trocar cartão",
          desc: "O novo cartão passa a ser usado nas próximas cobranças da assinatura.",
          close: "Fechar",
          successTitle: "Cartão atualizado!",
          numberLabel: "Número do cartão",
          holderLabel: "Nome impresso",
          holderPlaceholder: "Como está no cartão",
          expiryLabel: "Validade",
          expiryPlaceholder: "MM/AA",
          cvvLabel: "CVV",
          processing: "Processando...",
          save: "Salvar cartão",
          secureNote: "Seus dados vão direto e criptografados para a Pagar.me — não passam pelos nossos servidores.",
        },
        tasks: {
          createAi: { label: "Criar a IA da empresa", desc: "Crie seu atendente inteligente e teste na hora" },
          connectWhatsapp: { label: "Conectar WhatsApp", desc: "Conecte um número para começar a atender" },
          transferRule: { label: "Regra de transferência para humano", desc: "Defina quando a IA passa para um atendente" },
          registerUsers: { label: "Cadastrar usuários", desc: "Adicione outros usuários que irão atender pelo Sttelar Chat" },
          businessHours: { label: "Horário de atendimento", desc: "Configure os horários da sua operação" },
          quickMessage: { label: "Mensagem rápida", desc: "Crie respostas prontas para agilizar" },
          sectorsQueues: { label: "Criar setores", desc: "Organize os atendimentos por filas/setores" },
          tags: { label: "Configurar tags", desc: "Classifique seus atendimentos com etiquetas" },
          crmBoards: { label: "Configurar boards (CRM)", desc: "Gerencie leads e tarefas no Kanban" },
          academy: { label: "Finalizar treinamentos", desc: "Aprenda a usar a plataforma na Academy" },
        },
        aha: {
          title: "Criar a IA da empresa",
          subtitle: "Preencha os campos e crie seu atendente inteligente",
          create: "Criar minha IA",
          cancel: "Cancelar",
          done: "Concluir",
          requiredWarning: "Informe ao menos o nome da IA e o segmento.",
          successTitle: "Sua IA está pronta!",
          successSubtitle: "Teste agora mesmo uma pergunta",
          successMessage: "Pronto! Sua IA foi criada e já consegue responder seus primeiros clientes com base nas informações cadastradas.",
          fallbackNote: "Para testar a IA aqui, configure uma integração OpenAI em Integrações. A IA já foi criada e ficará pronta assim que a chave for cadastrada.",
          fields: {
            nomeIA: { label: "Nome da IA", placeholder: "Ex.: Sttela" },
            segmento: { label: "Segmento da empresa", placeholder: "Ex.: Clínica odontológica" },
            tom: { label: "Tom de atendimento", placeholder: "Escolha ou descreva o tom" },
            produtosServicos: { label: "Principais produtos ou serviços", placeholder: "O que vocês oferecem?" },
            duvidasFrequentes: { label: "Principais dúvidas frequentes", placeholder: "O que os clientes mais perguntam?" },
            regrasAtendimento: { label: "Regras básicas de atendimento", placeholder: "Ex.: sempre confirmar nome e telefone" },
            infosImportantes: { label: "Informações que a IA deve saber", placeholder: "Horários, endereço, políticas..." },
            situacoesTransferencia: { label: "Quando transferir para um humano", placeholder: "Ex.: reclamações ou pedidos complexos" },
          },
        },
      },
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome da empresa",
          email: "Email",
          phone: "Telefone com (DDD)",
          plan: "Plano",
          password: "Senha",
        },
        formErrors: {
          name: {
            required: "Nome da empresa é obrigatório",
            short: "Nome muito curto",
            long: "Nome muito longo",
          },
          password: {
            short: "Senha muito curta",
            long: "Senha muito longa",
          },
          email: {
            required: "Email é obrigatório",
            invalid: "Email inválido",
          },
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
        plan: {
          attendant: "Atendente",
          whatsapp: "WhatsApp",
          queues: "Filas",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          submitting: "Entrando...",
          register: "Registre-se, agora mesmo!",
        },
        errors: {
          emailRequired: "Email é obrigatório",
          emailInvalid: "Email inválido",
          passwordRequired: "Senha é obrigatória",
        },
        capsLockOn: "Caps Lock ativado",
      },
      tickets: {
        handledByAi: "Atendido por IA: {{name}}",
      },
      mfa: {
        setup: {
          title: "Configurar autenticação em duas etapas",
          scanQr: "Escaneie o QR Code com Google Authenticator, Duo Mobile ou app compatível.",
          manualSecret: "Não consegue escanear? Use este código manualmente:",
          next: "Próximo",
          back: "Voltar",
          confirmOtp: "Digite o código de 6 dígitos gerado pelo app:",
          confirm: "Confirmar",
          backupTitle: "Códigos de recuperação",
          backupHint: "Guarde em local seguro. Cada código é de uso único e substitui o app caso você perca o celular.",
          copyAll: "Copiar tudo",
          download: "Baixar .txt",
          savedAck: "Guardei meus códigos com segurança",
          oneTimeWarning: "Estes códigos serão exibidos uma única vez.",
          finish: "Concluir",
          cancel: "Cancelar",
          copied: "Códigos copiados",
        },
        login: {
          title: "Verificação em duas etapas",
          otpLabel: "Código do app autenticador",
          otpHint: "Digite o código de 6 dígitos do seu app.",
          backupLabel: "Código de recuperação",
          backupHint: "Use um dos códigos de recuperação que você salvou.",
          verify: "Verificar",
          useBackup: "Código de recuperação",
          useOtp: "Usar app autenticador",
          backToPassword: "Voltar",
        },
        policy: {
          title: "Política de MFA da empresa",
          modeOff: "Desativado",
          modeOptional: "Opcional",
          modeRequired: "Obrigatório",
          gracePeriod: "Prazo para configurar (dias)",
          saved: "Política atualizada",
          description: "Define se os usuários da empresa precisam configurar autenticação em duas etapas.",
        },
        profile: {
          menuItem: "Autenticação em duas etapas",
          statusEnabled: "Ativa desde {{date}}",
          statusDisabled: "Não configurada",
          enable: "Ativar",
          disable: "Desativar",
          disableConfirm: "Confirme com o código atual para desativar MFA",
          adminReset: "Resetar MFA do usuário",
          adminResetConfirm: "Tem certeza? O usuário precisará reconfigurar o app no próximo login.",
          adminResetDone: "MFA resetado",
          enabledDesc: "Seu acesso está protegido: a cada login você precisa fornecer o código do aplicativo autenticador.",
          disabledDesc: "Ative a autenticação em duas etapas para reforçar a segurança da sua conta. Você precisará de um app como Google Authenticator ou Duo Mobile.",
        },
        banner: {
          title: "Sua empresa exige autenticação em duas etapas.",
          subtitle: "Configure em até {{days}} dia(s) para continuar acessando.",
          cta: "Configurar agora",
        },
        errors: {
          invalidOtp: "Código inválido ou expirado",
          ticketExpired: "Sessão de verificação expirou. Faça login novamente.",
          backupUsed: "Código de recuperação já utilizado",
        },
      },
      resetPassword: {
        title: "Redefinir Senha",
        toasts: {
          emailSent: "Email enviado com sucesso!",
          emailNotFound: "Email não encontrado!",
          passwordUpdated: "Senha atualizada com sucesso!",
        },
        formErrors: {
          email: {
            required: "Email é obrigatório",
            invalid: "Email inválido",
          },
          newPassword: {
            required: "Nova senha é obrigatória",
            matches:
                "Sua senha precisa ter no mínimo 8 caracteres, sendo uma letra maiúscula, uma minúscula e um número.",
          },
          confirmPassword: {
            required: "Confirmação de senha é obrigatória",
            matches: "As senhas não correspondem",
          },
        },
        form: {
          email: "Email",
          verificationCode: "Código de verificação",
          newPassword: "Nova senha",
          confirmPassword: "Confirme a nova senha",
        },
        buttons: {
          submitEmail: "Enviar email",
          submitPassword: "Redefinir senha",
          back: "Não tem uma conta? Cadastre-se!",
        },
      },
      dashboard: {
        toasts: {
          selectFilterError: "Parametrize o filtro",
          userChartError: "Erro ao obter informações da conversa",
          dateChartError: "Erro ao obter informações da conversa",
          noResponseChartError: "Erro ao obter informações dos tickets sem resposta",
        },
        filters: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
          filterType: {
            title: "Tipo de Filtro",
            options: {
              perDate: "Filtro por Data",
              perPeriod: "Filtro por Período",
            },
            helper: "Selecione o tipo de filtro desejado",
          },
        },
        periodSelect: {
          title: "Período",
          options: {
            none: "Nenhum selecionado",
            last3: "Últimos 3 dias",
            last7: "Últimos 7 dias",
            last15: "Últimos 15 dias",
            last30: "Últimos 30 dias",
            last60: "Últimos 60 dias",
            last90: "Últimos 90 dias",
          },
          helper: "Selecione o período desejado",
        },
        counters: {
          inTalk: "Em conversa",
          waiting: "Aguardando",
          finished: "Finalizados",
          newContacts: "Novos contatos",
          averageTalkTime: "T.M. de Conversa",
          averageWaitTime: "T.M. de Espera",
        },
        buttons: {
          filter: "Filtrar",
        },
        onlineTable: {
          ratingLabel: "1 - Insatisfeito, 2 - Satisfeito, 3 - Muito Satisfeito",
          name: "Nome",
          ratings: "Avaliações",
          avgSupportTime: "T.M. de Atendimento",
          status: "Status (Atual)",
        },
        charts: {
          user: {
            label: "Gráfico de Conversas",
            title: "Total de Tickets Encerrados por Usuários",
            start: "Início",
            end: "Fim",
            filter: "Filtrar",
          },
          date: {
            label: "Gráfico de Conversas",
            title: "Total",
            start: "Início",
            end: "Fim",
            filter: "Filtrar",
          },
        },
      },
      dashboardGeral: {
        title: "Dashboard Geral",
        subtitle: "Visão consolidada do grupo {{groupName}}",
        accountsCount: "{{count}} contas",
        cards: {
          active: "Atendimentos Ativos",
          pending: "Pendentes",
          noResponse: "Sem Resposta +10min",
          noResponseRate: "Taxa sem resposta",
          avgPerAttendant: "Média/Atendente",
          art: "ART do Grupo",
        },
        table: {
          title: "Performance por Conta",
          headers: {
            account: "Conta",
            active: "Ativos",
            pending: "Pendentes",
            noResponse: "Sem Resp +10min",
            art: "ART",
            attendants: "Atendentes",
          },
        },
        states: {
          loading: "Carregando dashboard do grupo...",
          empty: "Nenhuma conta encontrada neste grupo",
          error: "Erro ao carregar dashboard. Tentar novamente?",
        },
      },
      plans: {
        toasts: {
          errorList: "Não foi possível carregar a lista de registros",
          errorOperation: "Não foi possível realizar a operação",
          error:
              "Não foi possível realizar a operação. Verifique se já existe uma plano com o mesmo nome ou se os campos foram preenchidos corretamente",
          success: "Operação realizada com sucesso!",
        },
        confirm: {
          title: "Exclusão de Registro",
          message: "Deseja realmente excluir o registro?",
        },
        buttons: {
          newCategory: "Nova Categoria",
          newPlan: "Novo Plano",
        },
        modal: {
          editPlan: "Editar Plano",
          newPlan: "Novo Plano",
          newCategory: "Nova Categoria",
          categoryName: "Nome da Categoria",
          categoryPlaceholder: "Ex: Premium, Enterprise, Starter",
          basicInfo: "Informações Básicas",
          emptyCategory: "Esta categoria está vazia. Clique em \"Novo Plano\" para adicionar.",
        },
        labels: {
          plans: "Planos",
          plan: "plano",
          plansPlural: "planos",
        },
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          queues: "Filas",
          value: "Valor",
          internalChat: "Chat Interno",
          externalApi: "API Externa",
          kanban: "CRM",
          integrations: "Integrações",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          leads: "CRM",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
        },
      },
      externalLeads: {
        title: "Boards",
        refresh: "Atualizar",
        stats: {
          total: "Total de Leads",
          unviewed: "Novos",
          pending: "Validados",
          completed: "Agendados",
        },
        filters: {
          searchPlaceholder: "Buscar por nome, telefone, CPF ou O.S...",
          status: "Status",
          all: "Todos",
          sortBy: "Ordenar por",
          newestFirst: "Mais recentes",
          oldestFirst: "Mais antigos",
        },
        card: {
          new: "Novo",
          notInformed: "Não informado",
          attachments: "anexo(s)",
          serviceOrderPlaceholder: "Ordem de Serviço",
          saveServiceOrder: "Salvar O.S.",
          noChanges: "Nenhuma alteração",
          viewDetails: "Ver detalhes",
          delete: "Excluir",
          startConversation: "Iniciar conversa no WhatsApp",
        },
        modal: {
          clientInfo: "Informações do Cliente",
          name: "Nome",
          phone: "Telefone",
          email: "E-mail",
          cpf: "CPF",
          address: "Endereço",
          serviceOrder: "Ordem de Serviço",
          attachments: "Anexos",
          customFields: "Campos Adicionais",
          changeStatus: "Alterar Status",
          receivedAt: "Recebido em:",
          viewedAt: "Visualizado em:",
          close: "Fechar",
        },
        confirmDelete: {
          title: "Excluir Lead",
          message: "Tem certeza que deseja excluir este lead? Esta ação não pode ser desfeita.",
        },
        empty: {
          title: "Nenhum lead encontrado",
          description: "Os leads recebidos via webhook aparecerão aqui",
        },
        loading: "Carregando...",
        toasts: {
          newLead: "Novo lead recebido:",
          deleted: "Lead excluído com sucesso",
          statusUpdated: "Status atualizado!",
          serviceOrderSaved: "Ordem de Serviço salva!",
        },
        defaultStatus: "Pendente",
      },
      kanban: {
        title: "CRM Kanban",
        toasts: {
          removed: "Tag removida do ticket!",
          added: "Tag adicionada com sucesso!",
          refreshed: "Dados atualizados!",
          errorLoadingTags: "Erro ao carregar tags",
          errorLoadingTickets: "Erro ao carregar tickets",
          errorMoving: "Erro ao mover card",
        },
        open: "Em aberto",
        seeTicket: "Ver Ticket",
        tickets: "tickets",
        columns: "colunas",
        refresh: "Atualizar",
        searchPlaceholder: "Buscar por nome ou número...",
        allQueues: "Todas as filas",
        loading: "Carregando tickets...",
        noMessage: "Sem mensagem",
        unknownContact: "Contato desconhecido",
      },
      companies: {
        title: "Cadastrar Empresa",
        buttons: {
          newGroup: "Novo Grupo",
          newCompany: "Nova Empresa",
        },
        modal: {
          editCompany: "Editar Empresa",
          newCompany: "Nova Empresa",
          newGroup: "Novo Grupo",
          groupName: "Nome do Grupo",
          groupPlaceholder: "Ex: Cliente XYZ",
        },
        labels: {
          companies: "Empresas",
          company: "empresa",
          companiesPlural: "empresas",
        },
        tooltips: {
          addUser: "Adicionar novo usuário",
          editUser: "Editar usuário existente",
          editCompany: "Editar empresa",
          deleteCompany: "Excluir empresa",
        },
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        token: "Token",
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
              "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
                "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
                "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
                "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        formErrors: {
          name: {
            required: "Nome é obrigatório",
            short: "Nome muito curto",
            long: "Nome muito longo",
          },
          expiresTicket: {
            number: "Informe um número válido",
            integer: "Use apenas números inteiros",
            min: "Valor mínimo é 0 (desligado)",
            max: "Valor máximo é 43200 minutos (30 dias)",
          },
          expiresInactiveMessage: {
            max: "Mensagem muito longa (máx 1000 caracteres)",
          },
          greetingAcceptedMessage: {
            max: "Mensagem muito longa (máx 1000 caracteres)",
          },
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "Avaliações",
          integrations: "Integrações",
          schedules: "Horário de expediente",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          sendIdQueue: "Fila",
          timeSendQueue: "Redirecionar para fila em X minutos",
          queueRedirection: "Redirecionamento de Fila",
          outOfHoursMessage: "Mensagem de fora de expediente",
          queueRedirectionDesc:
              "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          prompt: "Prompt",
          queue: "Fila de Transferência",
          timeToTransfer: "Transferir após x (minutos)",
          metaInfo: "Informe as credenciais do app no Facebook Developers para usar a API oficial do WhatsApp.",
          metaAccessToken: "Access Token",
          metaPhoneNumberId: "Phone Number ID",
          metaBusinessAccountId: "Business Account ID (opcional)",
          metaAppId: "App ID (opcional)",
          metaAppSecret: "App Secret",
          metaWebhookToken: "Webhook Verify Token",
          metaApiVersion: "Versão da Graph API",
          //maxUseBotQueues: "Enviar bot x vezes",
          //timeUseBotQueues: "Intervalo em minutos entre envio de bot",
          autoCloseTitle: "Encerramento automático",
          autoCloseHelp: "Fecha a conversa quando o cliente não responder ao atendente após o tempo definido. A mensagem abaixo é enviada antes do fechamento.",
          expiresTicket: "Tempo de inatividade",
          expiresTicketUnit: "minutos",
          expiresInactiveMessage: "Mensagem de encerramento",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          greetingAcceptedTitle: "Saudação ao aceitar ticket",
          greetingAcceptedMessage: "Mensagem ao aceitar atendimento",
          greetingAcceptedMessagePlaceholder: "Ex.: {{ms}} *{{name}}*, meu nome é *{{userName}}* e vou prosseguir com seu atendimento!",
          greetingAcceptedMessageHelp: "Enviada quando o atendente aceita um ticket pendente. Em branco, usa o texto padrão.",
          sendTransferQueueMessageTitle: "Mensagem ao transferir de fila",
          sendTransferUserMessageTitle: "Mensagem ao transferir de atendente",
          sendTransferQueueAndUserMessageTitle: "Mensagem ao transferir fila e atendente",
          integration: "Integrações"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCodeModal: {
        title: "Utilize o seu WhatsApp:",
        steps: {
          one: "1 - Abra o WhatsApp no seu celular",
          two: {
            partOne: "2 - Toque em Mais opções no Android",
            partTwo: "ou em Configurações",
            partThree: "no iPhone",
          },
          three:
              "3 - Toque em Dispositivos conectados e, em seguida, em Conectar dispositivos",
          four: "4 - Aponte seu celular para essa tela para capturar o QR Code",
        },
        waiting: "Aguardando leitura do QR Code",
        tabs: {
          qr: "QR Code",
          pairing: "Código de pareamento",
        },
        pairing: {
          title: "Conectar com código",
          phoneLabel: "Número com DDI e DDD",
          phonePlaceholder: "Ex: 5511999999999",
          generate: "Gerar código",
          generating: "Gerando...",
          instructions: "No WhatsApp do celular: Dispositivos conectados → Conectar com número → digite o código abaixo.",
          copy: "Copiar",
          copied: "Copiado!",
          invalidPhone: "Informe um número válido com DDI e DDD.",
        },
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
          deletedAll: "Todos contatos excluídos com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          deleteAllTitle: "Deletar Todos",
          importTitle: "Importar contatos",
          deleteMessage:
              "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          deleteAllMessage:
              "Tem certeza que deseja deletar todos os contatos? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importar todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contatos",
          delete: "Excluir Todos Contatos",
          startConversation: "Iniciar conversa no WhatsApp",
          edit: "Editar contato",
          deleteSingle: "Excluir contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      syncHistoryModal: {
        menuItem: "Sincronizar histórico",
        title: "Sincronizar histórico",
        description: "Traz mensagens antigas do WhatsApp pra dentro do atendimento. Disponível apenas para conexões não oficiais.",
        fields: {
          period: "Período",
          days7: "7 dias",
          days30: "30 dias",
          days90: "90 dias",
          custom: "Personalizado",
          customInput: "Período personalizado",
          customHint: "Escolha entre 1 e {{max}} dias",
          daysSuffix: "dias",
          downloadMedia: "Baixar mídias",
          downloadMediaHint: "Imagens, áudios e documentos. Mais lento.",
        },
        buttons: {
          sync: "Sincronizar",
          cancel: "Cancelar",
          background: "Continuar em background",
          close: "Fechar",
        },
        progress: {
          syncing: "Processando {{processed}} mensagens…",
          complete: "Sincronização concluída",
          truncated: "Limite de 2000 mensagens atingido. Rode novamente para pegar mais antigas.",
        },
        stats: {
          imported: "Importadas",
          skipped: "Já existentes",
          errors: "Erros",
        },
      },
      contactImportModal: {
        title: "Planilha de contatos",
        labels: {
          import: "Importar contatos",
          result: "resultados",
          added: "Adicionados",
          savedContact: "Contato salvo",
          errors: "Erros",
        },
        buttons: {
          download: "Baixar planilha modelo",
          import: "Importar contatos",
          background: "Continuar em segundo plano",
          close: "Fechar",
        },
        progress: {
          importing: "Importando {{processed}} de {{total}} contatos...",
          success: "{{count}} importados com sucesso",
          errors: "{{count}} com erro",
          complete: "Importação concluída",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      sideMenu: {
        name: "Menu Lateral Inicial",
        note: "Se habilitado, o menu lateral irá iniciar fechado",
        options: {
          enabled: "Aberto",
          disabled: "Fechado",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          model: "Modelo",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
        },
        formErrors: {
          name: {
            short: "Nome muito curto",
            long: "Nome muito longo",
            required: "Nome é obrigatório",
          },
          prompt: {
            short: "Prompt muito curto",
            required: "Descreva o treinamento para Inteligência Artificial",
          },
          modal: {
            required: "Informe o modelo desejado para o Prompt",
          },
          maxTokens: {
            required: "Informe o número máximo de tokens na resposta",
          },
          temperature: {
            required: "Informe a temperatura",
          },
          apikey: {
            required: "Informe a API Key",
          },
          queueId: {
            required: "Informe a fila",
          },
          maxMessages: {
            required: "Informe o número máximo de mensagens no histórico",
          },
        },
        success: "Prompt salvo com sucesso!",
        setor: "Informe o setor",
        title: {
          add: "Agentes de IA",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Inteligência Artificial",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Agentes de IA",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          basicInfo: "Informações básicas",
          complementaryInfo: "Dados complementares",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do WhatsApp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          whatsapp: "Conexão Origem: ",
        },
        formErrors: {
          name: {
            required: "Nome é obrigatório",
            short: "Nome muito curto",
            long: "Nome muito longo",
          },
          phone: {
            short: "Número muito curto",
            long: "Número muito longo",
          },
          email: {
            invalid: "Email inválido",
          },
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar setor",
          edit: "Editar setor",
        },
        form: {
          name: "Nome",
          nameShort: "Nome curto",
          nameLong: "Nome longo",
          nameRequired: "Nome é obrigatório",
          color: "Cor",
          colorShort: "Cor curta",
          colorLong: "Cor longa",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          ratingMessage: "Mensagem de avaliação",
          token: "Token",
          orderQueue: "Ordem do setor (Bot)",
          integrationId: "Integração",
        },  
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        toasts: {
          success: "Fila salva com sucesso.",
          info: "Clique em salvar para registar as alterações",
        },
        tabs: {
          queueData: "Dados do Setor",
          attendanceTime: "Horários de Atendimento",
        },
      },
      billing: {
        status: {
          teste_gratis: "Período de teste",
          pago_ativo: "Ativo",
          aguarda_pagamento: "Aguardando pagamento",
          aguarda_assinatura: "Aguardando assinatura",
          pagamento_vencido: "Pagamento vencido",
          bloqueado: "Bloqueado",
          cancelado: "Cancelado",
          onboarding: "Em configuração",
        },
        invoiceStatus: {
          paga: "Paga",
          pendente: "Pendente",
          falhou: "Falhou",
          cancelada: "Cancelada",
        },
        exempt: {
          title: "Conta cortesia",
          desc: "Uso gratuito — esta conta é isenta de cobrança.",
          badge: "Isento",
        },
        cancelError: "Não foi possível cancelar agora. Tente novamente.",
        loadError: "Não foi possível carregar as informações de cobrança no momento.",
        retry: "Tentar de novo",
        noOrder: "Nenhum pedido de cobrança encontrado para esta conta.",
        productFallback: "Sttelar Chat",
        cycleAnnual: "Anual",
        cycleMonthly: "Mensal",
        perCycleAnnual: "/mês · cobrado anualmente",
        perCycleMonthly: "/mês",
        userSingular: "usuário",
        userPlural: "usuários",
        withInternalChat: " · + Chat Interno",
        amount: "Valor",
        trialEndsOn: "Teste termina em",
        daySingular: "dia",
        dayPlural: "dias",
        nextCharge: "Próxima cobrança",
        manageUsers: "Gerenciar usuários",
        manageInternalChat: "Gerenciar Chat Interno",
        cancelNotice: "Assinatura cancelada — você mantém acesso até <strong>{{date}}</strong>. Não haverá novas cobranças.",
        pixNotice: "Plano anual via <strong>PIX</strong> · acesso até <strong>{{date}}</strong>. Renovação por novo PIX ao fim do período.",
        cancelSubscription: "Cancelar assinatura",
        paymentMethodTitle: "Forma de pagamento",
        noCard: "Nenhum cartão cadastrado",
        changeCard: "Trocar cartão",
        invoicesTitle: "Histórico de faturas",
        noInvoices: "Nenhuma fatura emitida ainda.",
        billingDataTitle: "Dados de cobrança",
        name: "Nome",
        email: "E-mail",
        document: "CPF/CNPJ",
        phone: "Telefone",
        address: "Endereço",
        zipPrefix: "CEP",
        cancelDialogText: "Sua assinatura deixa de renovar, mas você <strong>mantém acesso até {{date}}</strong> (fim do período já pago). Não haverá novas cobranças.",
        cancelDialogProAi: " A IA do plano Pro permanece ativa até lá.",
        keepSubscription: "Manter assinatura",
        cancelling: "Cancelando...",
      },
      userModal: {
        loading: "Carregando dados do usuário...",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          cpf: "CPF",
          password: "Senha",
          profile: "Perfil",
          jobRole: "Cargo",
          noJobRole: "Sem cargo",
          operationalType: "Tipo operacional",
          attendant: "Atendente",
          supervisor: "Supervisor",
          whatsapp: "Conexão Padrão",
          noWhatsapp: "Nenhuma conexão",
          queues: "Setores do Usuário",
          uploadPhoto: "Carregar Foto",

          allTicket: "Ticket Sem Fila [Invisível]",
          allTicketEnabled: "Habilitado",
          allTicketDesabled: "Desabilitado",
          accessScope: "Escopo de Acesso *",
          accessScopeFull: "Completo (Atendimento + Interno)",
          accessScopeAttendance: "Apenas Atendimento (Tickets, WhatsApp)",
          accessScopeInternal: "Apenas Interno (Chat, CRM)",
          internalLockedNotice: "Chat Interno não está incluso no seu plano. Faça upgrade em Configurações → Faturamento para liberar.",
        },
        formErrors: {
          name: {
            required: "Nome é obrigatório",
            short: "Nome muito curto",
            long: "Nome muito longo",
          },
          password: {
            short: "Senha muito curta",
            long: "Senha muito longa",
          },
          email: {
            required: "Email é obrigatório",
            invalid: "Email inválido",
          },
        },
        labels: {
          liberations: "Liberações",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
        },
        form: {
          name: "Nome",
          color: "Cor",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salvo com sucesso.",
      },
      chat: {
        toasts: {
          fillTitle: "Por favor, preencha o título da conversa.",
          fillUser: "Por favor, selecione pelo menos um usuário.",
        },
        modal: {
          title: "Conversa",
          titleField: "Título",
        },
        confirm: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
        chats: "Chats",
        messages: "Mensagens",
        noTicketMessage: "Selecione um ticket para começar a conversar.",
        buttons: {
          close: "Fechar",
          save: "Salvar",
          new: "Nova",
          newChat: "Novo",
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Setores",
        noQueue: "Sem fila",
      },
      tickets: {
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
          unauthorized: "Acesso não permitido",
        },
        filters: {
          user: "Filtro por usuários",
          tags: "Filtro por tags",
          connection: "Filtrar por conexão",
          queues: "Filtrar por Setores",
          emptyQueueWarning: "Selecione pelo menos uma fila (ou 'Sem fila') para aplicar o filtro.",
          tagsPlaceholder: "Filtrar por etiquetas",
          tagsPopoverTitle: "Etiquetas",
          tagsSearchPlaceholder: "Pesquisar",
          noTagsOption: "Sem etiquetas",
          noTagsFound: "Nenhuma etiqueta encontrada",
          singleSelected: "selecionado",
          multipleSelected: "selecionados",
          showingAll: "Exibindo todos os itens",
          clear: "Limpar",
          loadingTags: "Carregando etiquetas...",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Abertas" },
          groups: { title: "Grupos" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldUserLabel: "Atendente",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        userPlaceholder: "Selecione um atendente",
        userPopoverTitle: "Atendentes",
        userSearchPlaceholder: "Pesquisar atendentes",
        clearUserOption: "Limpar seleção",
        noUsersFound: "Nenhum atendente encontrado",
        showingAllUsers: "Exibindo todos os atendentes",
        noOptions: "Nenhum usuário encontrado com esse nome",
        noSelection: "Selecione um atendente ou uma fila para transferir.",
        queuePopoverTitle: "Filas",
        queueSearchPlaceholder: "Pesquisar filas",
        noQueueOption: "Sem fila",
        noQueuesFound: "Nenhuma fila encontrada",
        singleSelected: "item selecionado",
        showingAll: "Exibindo todas as filas",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        pendingHeaderTab: "Pendente",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
            "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        buttons: {
          accept: "Aceitar",
          closed: "Finalizar",
          reopen: "Reabrir",
        },
      },
      ticketsListItem: {
        tooltip: {
          chatbot: "Chatbot",
          peek: "Espiar Conversa",
          unreplied: "Sem resposta há mais de 10 minutos",
        },
        noQueue: "SEM FILA",
        viewLocation: "Ver localização no mapa",
        typing: "digitando...",
        recording: "gravando áudio...",
      },
      ticketAdvanced: {
        selectTicket: "Selecionar Ticket",
        ticketNav: "Ticket",
        attendanceNav: "Atendimentos",
      },
      newTicketModal: {
        title: "Escolha um contato",
        ticketTitle: "Escolha um ticket",
        searchPlaceholder: "Pesquisar por nome ou telefone",
        tagsPlaceholder: "Etiquetas",
        tagsPopoverTitle: "Etiquetas",
        tagsSearchPlaceholder: "Pesquisar",
        showingAll: "Exibindo todos os itens",
        singleSelected: "item selecionado",
        multipleSelected: "itens selecionados",
        clear: "Limpar",
        noTagsOption: "Sem etiquetas",
        noTagsFound: "Nenhuma etiqueta encontrada",
        createTicket: "Criar ticket",
        existingContactPlaceholder: "Pesquise um contato existente",
        contactSearchHint: "Digite pelo menos 3 caracteres para buscar um contato",
        queuePlaceholder: "Selecione uma fila",
        allQueuesOption: "Todas as filas",
        queuePopoverTitle: "Filas",
        queueSearchPlaceholder: "Pesquisar filas",
        noQueueOption: "Criar sem fila",
        noQueuesFound: "Nenhuma fila encontrada",
        connectionPlaceholder: "Selecione uma conexão",
        allConnectionsOption: "Todas as conexões",
        connectionPopoverTitle: "Conexões",
        loadingConnections: "Carregando conexões...",
        noConnectionsAvailable: "Nenhuma conexão disponível",
        newContact: "Novo contato",
        emptyState: "Nenhum contato encontrado",
        emptyTicketsState: "Nenhum ticket encontrado",
        loadingTags: "Carregando etiquetas...",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      locationPreview: {
        button: "Visualizar",
        openInMaps: "Abrir no Maps",
        showMap: "Ver no mapa",
        hideMap: "Ocultar mapa",
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          dashboardGeral: "Dashboard Geral",
          connections: "Conexões",
          tickets: "Atendimentos",
          quickMessages: "Respostas Rápidas",
          tasks: "Tarefas",
          contacts: "Contatos",
          queues: "Setores",
          tags: "Tags",
          academy: "Treinamentos",
          manageAcademy: "Gerenciar Treinamentos",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          flows: "Fluxos",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          files: "Lista de arquivos",
          prompts: "IA",
          queueIntegration: "Integrações",
          metaTemplates: "Templates Meta",
          integrations: "Integrações",
        },
        appBar: {
          refresh: "Recarregar página",
          notRegister: "Sem notificações",
          language: "Idioma",
          jobRole: "Cargo",
          noJobRole: "Sem cargo",
          appearance: "Aparência",
          notificationVolume: "Som das Notificações",
          greeting: {
						hello: "Olá",
						welcome: "Bem vindo a",
						active: "Ativo até",
					},
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
        },
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
              "Você tem certeza? Essa ação não pode ser revertida! e será removida dos setores e conexões vinculadas",
        },
      },
      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      messagesAPI: {
        title: "API",
        labels: {
          doc: "Documentação para envio de mensagens",
          method: "Métodos de Envio",
          textMessage: "Mensagem de Texto",
          mediaMessage: "Mensagem de Mídia",
          instructions: "Instruções",
          observations: "Observações importantes",
          before1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens.",
          before2:
              "Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
          numberDescription:
              "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
          countryCode: "Código do País",
          number: "Número",
          textMessage2: "1. Mensagens de Texto",
          textMessageInstructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          method2: "Método",
          e: "e",
          tests: "Teste de Envio",
          mediaMessage2: "2. Mensagens de Mídia",
        },
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        toasts: {
          unauthorized:
              "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
          success: "Mensagem enviada com sucesso!",
        },
        buttons: {
          send: "Enviar",
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
          error: "Erro ao salvar atalho.",
        },
        validation: {
          shortcodeRequired: "Informe o atalho da resposta rápida.",
          messageRequired: "Informe a mensagem da resposta rápida.",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      leadSettings: {
        tabs: {
          apiTokens: "Tokens de API",
          leadStatuses: "Status dos Leads",
        },
        tokens: {
          newToken: "Novo Token",
          webhookTitle: "URL do Webhook para N8N",
          webhookHint: "Envie o header:",
          copyUrl: "Copiar URL",
          urlCopied: "URL do webhook copiada!",
          emptyTitle: "Nenhum token criado",
          emptyDescription: "Crie um token de API para integrar com N8N ou outras plataformas",
          createdAt: "Criado em:",
          deleteTitle: "Excluir Token de API",
          deleteMessage: "Tem certeza que deseja excluir o token \"{name}\"? Esta ação não pode ser desfeita e todas as integrações que usam este token deixarão de funcionar.",
          deleted: "Token excluído com sucesso",
        },
        statuses: {
          newStatus: "Novo Status",
          emptyTitle: "Nenhum status criado",
          emptyDescription: "Crie status personalizados para organizar seus leads",
          default: "Padrão",
          pending: "Pendente",
          completed: "Concluído",
          order: "Ordem",
          deleteTitle: "Excluir Status",
          deleteMessage: "Tem certeza que deseja excluir o status \"{name}\"? Leads com este status serão movidos para o status padrão.",
          deleted: "Status excluído com sucesso",
        },
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          nameShort: "Nome curto",
          nameLong: "Nome longo",
          nameRequired: "Nome é obrigatório",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
          success: "Operação realizada com sucesso",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        download: "Clique aqui para baixar planilha exemplo.",
        dialog: {
          name: "Nome",
          nameShort: "Nome curto",
          nameLong: "Nome longo",
          nameRequired: "Nome é obrigatório",
          number: "Número",
          numberShort: "Número curto",
          numberLong: "Número longo",
          whatsapp: "Whatsapp",
          email: "E-mail",
          emailInvalid: "E-mail inválido",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        report: {
          title: "Relatório de",
          title2: "Disparo",
          of: "de",
          validContacts: "Contatos válidos",
          delivered: "Entregues",
          connection: "Conexão",
          contactList: "Lista de Contatos",
          schedule: "Agendamento",
          conclusion: "Conclusão",
        },
        config: {
          interval: "Intervalos",
          randomInterval: "Intervalo Randômico de Disparo",
          biggerInterval: "Intervalo Maior Após",
          greaterInterval: "Intervalo de Disparo Maior",
          noInterval: "Sem Intervalo",
          second: "segundo",
          seconds: "segundos",
          notDefined: "Não definido",
          addVariable: "Adicionar Variável",
          save: "Salvar Configurações",
          shortcut: "Atalho",
          content: "Conteúdo",
          close: "Fechar",
          add: "Adicionar",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        status: {
          inactive: "Inativa",
          programmed: "Programada",
          inProgress: "Em andamento",
          canceled: "Cancelada",
          finished: "Finalizada",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
          notDefined: "Não definida",
          notDefined2: "Não definido",
          notScheduled: "Sem agendamento",
          notConcluded: "Não concluída",
          stopCampaign: "Parar Campanha",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          form: {
            name: "Nome",
            nameShort: "Nome curto",
            nameLong: "Nome longo",
            helper:
                "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalziadas.",
            nameRequired: "Nome é obrigatório",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Lista de Tags",
            fileList: "Lista de Arquivos",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          configSaved: "Configurações salvas",
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
      },
      announcements: {
        active: "Ativo",
        inactive: "Inativo",
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        high: "Alta",
        medium: "Média",
        low: "Baixa",
        buttons: {
          add: "Criar Novo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            required: "Campo obrigatório",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
          info: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Setores",
        table: {
          id: "ID",
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
          orderQueue: "Ordenação do setor (bot)",
        },
        buttons: {
          add: "Adicionar fila",
        },
        emptyState: "Nenhuma fila encontrada",
        toasts: {
          success: "Fila deletada com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
              "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Setores",
      },
      users: {
        title: "Usuários",
        table: {
          id: "ID",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          admin: "Admin",
          user: "Usuário",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        seatLimitReached: "Você atingiu o limite de usuários do seu plano. Faça upgrade em Configurações → Faturamento para adicionar mais.",
        emptyState: "Nenhum usuário encontrado",
        toasts: {
          created: "Usuário criado com sucesso.",
          deleted: "Usuário excluído com sucesso.",
          updated: "Usuário atualizado com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
              "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      todolist: {
        input: "Nova tarefa",
        buttons: {
          add: "Adicionar",
          save: "Salvar",
        },
      },
      helps: {
        title: "Central de Ajuda",
      },
      schedules: {
        title: "Agendamentos",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        messages: {
          date: "Data",
          time: "Hora",
          event: "Evento",
          allDay: "Dia Todo",
          week: "Semana",
          work_week: "Agendamentos",
          day: "Dia",
          month: "Mês",
          previous: "Anterior",
          next: "Próximo",
          yesterday: "Ontem",
          tomorrow: "Amanhã",
          today: "Hoje",
          agenda: "Agenda",
          noEventsInRange: "Não há agendamentos no período.",
          showMore: "mais",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
          deleteAllMessage: "Tem certeza que deseja deletar todas as Tags?",
          deleteAllTitle: "Deletar Todos",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Registros Tagdos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
          deleteAll: "Deletar Todas",
        },
        toasts: {
          deletedAll: "Todas Tags excluídas com sucesso!",
          deleted: "Tag excluído com sucesso.",
        },
      },
      settings: {
        schedulesUpdated: "Horários atualizados com sucesso.",
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          options: "Opções",
          jobRoles: "Cargos",
          security: "Segurança",
          schedules: "Horários",
          companyData: "Dados da Empresa",
          billing: "Faturamento",
          companies: "Empresas",
          plans: "Planos",
          helps: "Ajuda",
        },
        companyData: {
          title: "Dados da Empresa",
          subtitle: "Dados fiscais usados na cobrança e em documentos.",
          accountLabel: "Conta",
          razaoSocial: "Razão Social",
          nomeFantasia: "Nome Fantasia",
          cnpj: "CNPJ",
          phone: "Telefone",
          email: "E-mail",
          phRazaoSocial: "Ex: Comércio de Roupas LTDA",
          phNomeFantasia: "Ex: Loja do João",
          phEmail: "financeiro@empresa.com",
          save: "Salvar",
          saved: "Dados atualizados com sucesso.",
          primaryBadge: "Conta principal de cobrança",
          primaryHint: "O CNPJ e o e-mail desta conta alimentam a cobrança (Pagar.me) e o pedido no painel.",
          invalidCnpj: "CNPJ inválido. Verifique os dígitos.",
        },
        jobRoles: {
          title: "Cargos",
          emptyState: "Nenhum cargo cadastrado para esta empresa.",
          modal: {
            add: "Novo cargo",
            edit: "Editar cargo",
          },
          form: {
            name: "Nome do cargo",
          },
          buttons: {
            add: "Adicionar cargo",
            cancel: "Cancelar",
            save: "Salvar",
          },
          toasts: {
            created: "Cargo criado com sucesso.",
            updated: "Cargo atualizado com sucesso.",
            deleted: "Cargo excluído com sucesso.",
          },
          confirmationModal: {
            deleteTitle: "Excluir cargo",
            deleteMessage: "Os usuários vinculados a este cargo passarão automaticamente para Sem cargo.",
          },
        },
        options: {
          toasts: {
            success: "Operação atualizada com sucesso.",
            webNotificationsUnsupported: "Este navegador não suporta notificações web.",
            webNotificationsPermissionDenied: "Permissão de notificação não concedida no navegador.",
          },
          fields: {
            ratings: {
              title: "Avaliações",
              disabled: "Desabilitadas",
              enabled: "Habilitadas",
            },
            expedientManager: {
              title: "Gerenciamento de Expediente",
              queue: "Fila",
              company: "Empresa",
            },
            ignoreMessages: {
              title: "Ignorar Mensagens de Grupos",
            },
            acceptCall: {
              title: "Aceitar Chamada",
              disabled: "Não aceitar",
              enabled: "Aceitar",
            },
            chatbotType: {
              title: "Tipo Chatbot",
              text: "Texto",
            },
            sendGreetingMessageOneQueues: {
              title: "Enviar saudação quando houver somente 1 fila<",
            },
            quickMessagesScope: {
              title: "Respostas Rápidas",
              description: "Defina se respostas rápidas são compartilhadas por usuário ou empresa",
              user: "Por Usuário",
              company: "Por Empresa",
            },
            noResponseBusinessHours: {
              title: "Horário Comercial no Gráfico",
              description: "Filtrar o histórico de sem resposta apenas para horários comerciais configurados",
            },
            webNotifications: {
              title: "Notificações Web",
              description: "Exibir notificação do navegador para novas mensagens de tickets",
            },
            internalChatNotifications: {
              title: "Notificações do Chat Interno",
              description: "Exibir notificação do navegador para DMs e menções no Chat Interno",
            },
            enableAcademy: {
              title: "Área de Treinamento",
              description: "Exibir a página de Treinamentos (Academy) para esta empresa",
            },
            disabled: "Desabilitado",
            active: "Ativo",
            enabled: "Habilitado",
            artThresholds: {
              title: "ART — Tempo de Resposta",
              description: "Define limites em minutos para classificar o tempo médio de resposta (verde, amarelo, vermelho).",
              yellowLabel: "Limite amarelo (min)",
              redLabel: "Limite vermelho (min)",
              invalidRange: "Limite vermelho deve ser maior que amarelo (1–1440).",
            },
          },
          updating: "Atualizando...",
          tabs: {
            integrations: "INTEGRAÇÕES",
          },
        },
        helps: {
          toasts: {
            errorList: "Não foi possível carregar a lista de registros",
            errorOperation: "Não foi possível realizar a operação",
            error:
                "Não foi possível realizar a operação. Verifique se já existe uma helpo com o mesmo nome ou se os campos foram preenchidos corretamente",
            success: "Operação realizada com sucesso!",
          },
          buttons: {
            clean: "Limpar",
            delete: "Excluir",
            save: "Salvar",
          },
          grid: {
            title: "Título",
            description: "Descrição",
            video: "Vídeo",
          },
          confirmModal: {
            title: "Exclusão de Registro",
            confirm: "Deseja realmente excluir esse registro?",
          },
        },
        company: {
          toasts: {
            errorList: "Não foi possível carregar a lista de registros",
            errorOperation: "Não foi possível realizar a operação",
            error:
                "Não foi possível realizar a operação. Verifique se já existe uma empresa com o mesmo nome ou se os campos foram preenchidos corretamente",
            success: "Operação realizada com sucesso!",
          },
          confirmModal: {
            title: "Exclusão de Registro",
            confirm: "Deseja realmente excluir esse registro?",
          },
          form: {
            name: "Nome",
            email: "E-mail",
            phone: "Telefone",
            plan: "Plano",
            status: "Status",
            yes: "Sim",
            no: "Não",
            campanhas: "Campanhas",
            enabled: "Habilitadas",
            disabled: "Desabilitadas",
            createdAt: "Criada Em",
          },
          buttons: {
            clear: "Limpar",
            delete: "Excluir",
            user: "Usuário",
            save: "Salvar",
          },
        },
        schedules: {
          form: {
            weekday: "Dia da Semana",
            initialHour: "Hora Inicial",
            finalHour: "Hora Final",
            save: "Salvar",
          },
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            download: "Baixar",
          },
        },
        lostCall: "Chamada de voz/vídeo perdida às",
        deletedMessage: "Essa mensagem foi apagada pelo contato",
        edited: "Editada",
        audio: "Áudio",
        location: "Localização",
        saudation: "Diga olá para seu novo contato!",
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem",
        placeholderClosed:
            "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        formErrors: {
          name: {
            required: "Nome é obrigatório",
            short: "Nome muito curto",
          },
          message: {
            required: "Mensagem é obrigatória",
          },
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        appointmentsModal: {
          title: "Observações do Contato",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket",
          titleFrom: "do contato ",
          message:
              "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        forward: "Encaminhar",
        edit: "Editar",
        retry: "Reenviar",
        retrying: "Reenviando...",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      editMessageModal: {
        title: "Editar mensagem",
        originalMessage: "Mensagem original:",
        newMessage: "Nova mensagem",
        characters: "caracteres",
        timeRemaining: "Tempo restante",
        timeExpired: "Tempo para edição expirou",
        success: "Mensagem editada com sucesso!",
        errors: {
          emptyMessage: "A mensagem não pode estar vazia",
          noChanges: "Nenhuma alteração detectada",
          timeExpired: "O tempo para edição expirou (limite de 10 minutos)",
        },
        buttons: {
          cancel: "Cancelar",
          save: "Salvar",
        },
      },
      academy: {
        title: "Treinamentos",
        empty: "Nenhum curso disponível no momento.",
        lessons: "aulas",
        progress: "concluído",
        courseContent: "Conteúdo do curso",
        ofLessonsCompleted: "de {{total}} concluídos",
        lessonTag: "AULA",
        back: "Voltar",
        videoUnavailable: "Vídeo indisponível",
        continueWatching: "Continuar assistindo",
        courseCompleted: "Curso concluído",
        markComplete: "Marcar como concluída",
        unmarkComplete: "Desmarcar",
        toasts: {
          disabled: "A Área de Treinamento está desativada.",
          noPermission: "Você não tem permissão para acessar esta área.",
        },
        manage: {
          title: "Gerenciar Treinamentos",
          draft: "Rascunho",
          buttons: {
            cancel: "Cancelar",
            save: "Salvar",
            addCourse: "Novo curso",
            addModule: "Novo módulo",
          },
          validation: {
            titleRequired: "Informe um título (mín. 2 caracteres).",
            videoUrlRequired: "Informe a URL do vídeo.",
          },
          toasts: {
            courseSaved: "Curso salvo.",
            moduleSaved: "Módulo salvo.",
            lessonSaved: "Aula salva.",
            thumbnailRemoved: "Thumbnail removida.",
          },
          confirm: {
            deleteCourse: "Excluir curso",
            deleteModule: "Excluir módulo",
            deleteLesson: "Excluir aula",
            message: "Esta ação não pode ser desfeita.",
          },
          courseModal: {
            addTitle: "Novo curso",
            editTitle: "Editar curso",
            title: "Título",
            description: "Descrição",
            published: "Publicado",
            thumbnail: "Thumbnail (imagem)",
            removeThumbnail: "Remover",
          },
          moduleModal: {
            addTitle: "Novo módulo",
            editTitle: "Editar módulo",
            title: "Título",
          },
          lessonModal: {
            addTitle: "Nova aula",
            editTitle: "Editar aula",
            title: "Título",
            description: "Descrição",
            videoUrl: "URL do vídeo (YouTube ou Vimeo)",
            currentVideo: "Vídeo atual",
            keepHint: "deixe a URL em branco para manter",
          },
        },
      },
      backendErrors: {
        ERR_ACADEMY_DISABLED: "A Área de Treinamento está desativada para esta empresa.",
        ERR_ACADEMY_INVALID_VIDEO_URL: "URL de vídeo inválida. Use um link do YouTube ou Vimeo.",
        ERR_ACADEMY_COURSE_NOT_FOUND: "Curso não encontrado.",
        ERR_ACADEMY_MODULE_NOT_FOUND: "Módulo não encontrado.",
        ERR_ACADEMY_LESSON_NOT_FOUND: "Aula não encontrada.",
        ERR_INTERNAL_SERVER_ERROR:
            "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
            "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
            "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
            "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
            "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
            "Usuário ou senha incorretos",
        ERR_USER_DONT_EXISTS:
            "Usuário não encontrado. Verifique o e-mail informado.",
        ERR_SENDING_WAPP_MSG:
            "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_EDIT_WAPP_MSG: "Não foi possível editar a mensagem do WhatsApp.",
        ERR_EDIT_ONLY_OWN_MESSAGES: "Você só pode editar suas próprias mensagens.",
        ERR_EDIT_ONLY_WAHA_PROVIDER: "Edição de mensagens só está disponível para conexões não oficiais.",
        ERR_EDIT_TIME_LIMIT_EXCEEDED: "O tempo para edição expirou (limite de 10 minutos).",
        ERR_CANNOT_EDIT_DELETED_MESSAGE: "Não é possível editar uma mensagem deletada.",
        ERR_CANNOT_EDIT_MEDIA_MESSAGE: "Não é possível editar mensagens com mídia.",
        ERR_EMPTY_MESSAGE_BODY: "A mensagem não pode estar vazia.",
        ERR_META_API_DELETE_NOT_ALLOWED: "A Meta Cloud API não permite deletar mensagens enviadas. Esta é uma limitação da API oficial do WhatsApp Business.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
            "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_CANNOT_REMOVE_ACTIVE_COMPANY: "Não é possível remover a Conta ativa do usuário. Defina outra Conta como principal antes.",
        ERR_COMPANY_NOT_ASSIGNED: "Esta Conta não está vinculada ao usuário.",
        ERR_COMPANY_ALREADY_ASSIGNED: "Esta Conta já está vinculada ao usuário.",
        ERR_COMPANY_NOT_IN_GROUP: "A Conta precisa pertencer à mesma Empresa do usuário.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_MAX_PINNED_TICKETS: "Máximo de 3 conversas fixadas atingido.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_TICKET_NO_CONNECTION: "Este ticket não possui uma conexão WhatsApp definida. Selecione uma conexão antes de resolver.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
            "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
            "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
            "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_QUICKMESSAGE_DUPLICATED_SHORTCODE:
            "Já existe uma resposta rápida com este atalho. Por favor, escolha outro.",
        ERR_QUICKMESSAGE_INVALID_NAME:
            "O atalho deve ter no mínimo 3 caracteres.",
        ERR_QUICKMESSAGE_REQUIRED:
            "O atalho e a mensagem são obrigatórios.",
        ERR_TAG_INVALID_NAME:
            "O nome da etiqueta deve ter no mínimo 3 caracteres.",
        ERR_TAG_NAME_REQUIRED:
            "O nome da etiqueta é obrigatório.",
      },
      messageSearch: {
        title: "Pesquisar mensagens com",
        placeholder: "Pesquisar mensagens...",
        noResults: "Nenhuma mensagem encontrada",
        startTyping: "Digite algo para pesquisar mensagens",
      },
      templateModal: {
        title: "Selecionar Template",
        searchPlaceholder: "Buscar por nome ou conteúdo...",
        loading: "Carregando templates...",
        recents: "Recentes",
        favorites: "Favoritos",
        favorite: "Favoritar template",
        unfavorite: "Remover dos favoritos",
        all: "Todos",
        previewEmpty: "Selecione um template para ver o preview",
        sentToast: "Template \"{name}\" enviado com sucesso!",
        categories: {
          all: "Todos",
          marketing: "Marketing",
          utility: "Utilitário",
          auth: "Autenticação",
          other: "Outro",
        },
        empty: {
          title: "Nenhum template encontrado",
          description: "Configure templates aprovados na sua conta Meta for Developers para usar esta funcionalidade.",
        },
        noResults: {
          title: "Sem resultados",
          description: "Tente outra busca ou remova o filtro de categoria.",
        },
        hints: {
          navigate: "navegar",
          send: "enviar",
          close: "fechar",
        },
        buttons: {
          cancel: "Cancelar",
          send: "Enviar template",
          sending: "Enviando...",
        },
      },
      internalChat: {
        jobRoleRequired: {
          title: "Selecione seu cargo",
          intro: "Pra usar o Chat Interno, escolha o cargo que melhor representa sua função na empresa. Ele aparecerá ao lado do seu nome nas conversas.",
          empty: "Nenhum cargo cadastrado. Peça ao administrador pra cadastrar cargos em Configurações → Cargos.",
          confirm: "Confirmar",
          saving: "Salvando...",
          toastSaved: "Cargo definido",
        },
      },
    },
  },
};

export { messages };
